// ===== Tipos Globais LICMAB =====

export interface Usuario {
  id: string;
  email: string;
  nome?: string;
}

export interface AuthState {
  usuario: Usuario | null;
  token: string | null;
  carregando: boolean;
}

export interface Documento {
  id: string;
  titulo: string;
  categoria: CategoriaDocumento;
  nota?: string | null;
  data?: string | null;
  nomeArquivo?: string | null;
  tipoArquivo: string;
  tamanhoArquivo: number;
  status: 'ativo' | 'inativo' | 'arquivado';
  urlPublica?: string | null;
  criadoPor?: string | null;
  criadoEm: string;
  atualizadoEm: string;
}

export type CategoriaDocumento =
  | 'ata'
  | 'balancete'
  | 'relatorio'
  | 'estatuto'
  | 'certidao'
  | 'convenio'
  | 'outro';

export const CATEGORIAS_DOCUMENTO: { value: CategoriaDocumento; label: string }[] = [
  { value: 'ata', label: 'Ata' },
  { value: 'balancete', label: 'Balancete' },
  { value: 'relatorio', label: 'Relatório' },
  { value: 'estatuto', label: 'Estatuto' },
  { value: 'certidao', label: 'Certidão' },
  { value: 'convenio', label: 'Convênio' },
  { value: 'outro', label: 'Outro' },
];

export interface Imagem {
  id: string;
  titulo: string;
  pagina: PaginaGaleria;
  urlPublica: string;
  ordem: number;
  criadoEm: string;
}

export type PaginaGaleria =
  | 'eventos'
  | 'festejo'
  | 'galeria'
  | 'capa'
  | 'logo';

export const PAGINAS_GALERIA: { value: PaginaGaleria; label: string }[] = [
  { value: 'eventos', label: 'Eventos' },
  { value: 'festejo', label: 'Festejo Junino' },
  { value: 'galeria', label: 'Galeria Geral' },
  { value: 'capa', label: 'Imagem de Capa do Site' },
  { value: 'logo', label: 'Logo da LICMAB' },
];

export interface Evento {
  id: string;
  titulo: string;
  descricao: string;
  data: string;
  local?: string | null;
  imagem?: string | null;
  status: 'ativo' | 'inativo';
  destaque: boolean;
  criadoEm: string;
}

export interface SiteConfig {
  capaUrl?: string;
  logoUrl?: string;
}

export interface PaginacaoInfo {
  pagina: number;
  totalPaginas: number;
  total: number;
  limite: number;
}

export interface RespostaListaDocumentos {
  documentos: Documento[];
  total: number;
  pagina: number;
  totalPaginas: number;
  limite: number;
}

export interface RespostaListaImagens {
  imagens: Imagem[];
  total: number;
}
